import * as types from './action-types';
import { range } from 'lodash';
import { generationReducer, GenerationState } from './generation-reducer';
import { generations } from '../templates/fanchart';

const GenerationsState = () => ({
  generations: range(0, 10).map(i => generationReducer(GenerationState(i), {type: null, payload: null})),
});

export function generationsReducer(state = GenerationsState(), {generation, payload, type}) {
  switch (type) {
    case types.SET_THICKNESS:
    case types.SET_FONT_SIZE:
    case types.SET_CELL_TYPE:
    case types.SET_OFFSET:
    case types.SET_STROKE_VISIBLE:
      return Object.assign({}, state, {
        generations: [
          ...state.generations.slice(0, generation),
          generationReducer(state.generations[generation], {payload, type}),
          ...state.generations.slice(generation + 1),
        ]
      })
    case types.BATCH_UPDATE_GENERATIONS:
      return Object.assign({}, state, {
        generations: state.generations.map((generation, i) => ({
          ...generation,
          ...(payload[i] || {})
        }))
      })
      
    
    default: 
      return state;

  }
}


// WEBPACK FOOTER //
// ./src/core/generations/reducer.js